<!--
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-20 19:20:03
-->
<template>
   <div class="speech-album-page page-container home-page">
    <div class="banner-bl">
      <div class="banner-content content">
        <div class="banner_title">{{ album.title }}</div>
        <div class="banner_subtitle">{{ album.intro }}</div>
      </div>
    </div>
    <div class="content">
    
      <!-- 演讲 SWIPER START -->
      <div class="speech-bl">
        
        <div class="total_number content">共{{ album.count }}个演讲</div>
        <div class="speech-swiper-bl">
          <swiper class="swiper" :options="speechSwiperOption" ref="speechSwiper" @click="onClickSpeechItem">
            <swiper-slide v-for="(list, index) in speechSwiperPages" :key="index">
              <div class="swiper-page">
                <div class="speech-item" v-for="item in list" :key="item.id" :data-id="item.id">
                  <div class="cover-wrap no-pointer-evts">
                    <img :src="item.cover" :alt="item.title" />
                    <div class="video_time">{{ item.time }}</div>
                  </div>
                  <div class="video_intro-wrap no-pointer-evts">
                    <div class="video_intro--content">
                      <div class="video_title">{{ item.title }}</div>
                      <div class="speaker_intro-wrap">
                        <span class="speaker_name">{{ item.speaker.name }}</span>
                        <span class="speaker_intro">{{ item.speaker.intro }}</span>
                      </div>
                      <div class="video_intro">
                        {{ item.titlelanguage }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-btn-wrap"
            ref="speechSwiperBtns"
            :style="{ top: `${ssbsIndex * (SPEECH_SWIPER_ITEM_HEIGHT + SPEECH_SWIPER_ITEM_GAP)}px` }"
          >
            <div class="speech swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="speech swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 演讲 SWIPER END -->
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';

// 演讲swiper常量
const SPEECH_SWIPER_PAGE_SIZE = 60; // 演讲一页展示个数
const SPEECH_SWIPER_PAGE_ROW = 15; // 演讲一页展示行数
const SPEECH_SWIPER_ITEM_HEIGHT = 256; // 演讲单个模块高度
const SPEECH_SWIPER_ITEM_GAP = 20; // 演讲模块间距


export default {
  data() {
    return {
      // swiper options
      speechSwiperOption: {
        navigation: {
          prevEl: '.speech.swiper-btn-prev',
          nextEl: '.speech.swiper-btn-next',
        },
      },
      // speech parmas 演讲
      speechSwiperPages: [], // 演讲swiper页数组
      speechPageNum: 1,
      speechSize: 24,
      ssbsIndex: 0, // 演讲按钮上下滚动index
      SPEECH_SWIPER_ITEM_HEIGHT,
      SPEECH_SWIPER_ITEM_GAP,
	  albumId:this.$route.query.id,
      album: {
        title: 'Top 50',
        intro: '排名不分先后',
      },
    };
  },
  mounted() {
    this._addEvent();
  },
  beforeDestroy() {
    this._removeEvent();
  },
  // created() {
  //   this.getSpeechData();
  // },
  activated() {
	  this.speechSwiperPages = [];
    this.albumId = +this.$route.query.id;
	this.getSpeechData();
  },
  methods: {
    _addEvent() {
      window.addEventListener('scroll', this._scrollEvent);
    },
    _removeEvent() {
      window.removeEventListener('scroll', this._scrollEvent);
    },
    /**
     * @description: 监听滚动事件 用来对模块右侧翻页按钮进行动态定位
     */
    _scrollEvent() {
      if (this.scrollTimer) {
        return;
      }
      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;
        const topBarH = document.getElementsByClassName('top_bar-base')[0].offsetHeight;
        const ssbt = this.$refs.speechSwiperBtns.getBoundingClientRect().top; // speech swiper btns wrap top 演讲翻页按钮距离顶部距离
        // 计算出步进粒度
        const n = Math.round(Math.abs(ssbt - topBarH) / (SPEECH_SWIPER_ITEM_HEIGHT + SPEECH_SWIPER_ITEM_GAP));
        const max = SPEECH_SWIPER_PAGE_ROW - 1;
        if (ssbt - topBarH < 0 && this.ssbsIndex < SPEECH_SWIPER_PAGE_ROW) {
          this.ssbsIndex += n > max ? max : n;
          this.ssbsIndex = this.ssbsIndex > max ? max : this.ssbsIndex;
        } else if (ssbt - topBarH > SPEECH_SWIPER_ITEM_HEIGHT + SPEECH_SWIPER_ITEM_GAP && this.ssbsIndex > 0) {
          this.ssbsIndex -= n > max ? max : n;
          this.ssbsIndex = this.ssbsIndex < 0 ? 0 : this.ssbsIndex;
        }
      }, 500);
    },
    /**
     * @description: 获取演讲列表
     */
    getSpeechData() {
      requestApi(`/v3/api/site/album/${this.albumId}/detail/`, {
        page: this.speechPageNum,
        page_size: this.speechSize,
      }).then(res => {
        if (this.speechPageNum === 1) {
          this.speechSwiperPages = this.handleData(res.items, SPEECH_SWIPER_PAGE_SIZE);
          this.album = res.base;
        } else {
          this.speechSwiperPages = this.speechSwiperPages.concat(this.handleData(res.items, SPEECH_SWIPER_PAGE_SIZE));
        }
        this._addEvent();
      });
    },
    handleData(data, size) {
      const list = [];
      while (data.length > 0) {
        list.push(data.splice(0, size));
      }
      return list;
    },
    /**
     * @description: 事件委托 演讲点击
     */
    onClickSpeechItem(e) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id: e.target.dataset.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-bl {
  width: 100%;
  background: url('../assets/imgs/album-d-bg.jpg') no-repeat;
  background-position: center;
  background-size: cover;
  height: 260px;
  .banner-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .banner_title {
      position: relative;
      font-family: HYXinRenWenSongW;
      font-size: 47px;
      color: $C1;
      letter-spacing: 3px;
      text-align: left;
      margin: 0;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        height: 1px;
        width: 80%;
        background: $C1;
      }
    }
    .banner_subtitle {
      margin-top: 6px;
      font-size: 16px;
      color: $C1;
      letter-spacing: 2px;
      text-align: center;
      line-height: 22px;
      width: 360px;
    }
  }
}
.total_number {
  font-size: 25px;
  font-family: HYXinRenWenSongW;
  color: $C6;
  cursor: pointer;
  line-height: 1;
  padding: 20px 0;
  margin-top: 20px;
  margin-left:0px;
}
.home-page {
  width: 100%;
  box-sizing: border-box;
  .content {
    .speech-bl,
    .activity-bl,
    .wanxiang-bl,
    .zhiya-bl,
    .record-bl {
      width: 100%;
      margin-bottom: 20px;
      .title-bl {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 17px 0;
        .title-wrap {
          .title {
            font-size: 25px;
            color: $C6;
            font-family: HYXinRenWenSongW;
            display: inline-block;
          }
          .subtitle {
            font-size: 12px;
            color: $C9;
            font-weight: 300;
            letter-spacing: 4px;
            margin-left: 10px;
            display: inline-block;
          }
        }
        .more_btn {
          font-size: 12px;
          color: $C3;
          font-weight: 300;
          margin-top: 10px;
          display: inline-block;
          cursor: pointer;
          &:hover {
            color: $C7;
          }
        }
      }
    }
    .zhiya-bl,
    .record-bl {
      .title-wrap .subtitle {
        letter-spacing: 4px;
      }
    }
  }
  .speech-swiper-bl,
  .activity-swiper-bl,
  .wanxiang-swiper-bl,
  .zhiya-swiper-bl,
  .record-swiper-bl {
    position: relative;
  }
  .activity-swiper-bl .swiper {
    padding-bottom: 10px;
  }
  .swiper {
    margin-left: auto;
    margin-right: auto;
    .swiper-slide {
      .swiper-page {
        margin: -10px;
        width: calc(100% + 20px);
        height: 100%;
      }
      .speech-item,
      .wanxiang-item {
        display: inline-block;
        vertical-align: bottom;
        width: calc(25% - 20px);
        height: 256px;
        max-height: 256px;
        max-width: 270px;
        overflow: hidden;
        margin: 10px;
      }
      .speech-item,
      .activity-item,
      .wanxiang-item,
      .zhiya-item,
      .record-item {
        position: relative;
        background-color: $C9;
        cursor: pointer;
        .cover-wrap {
          height: 160px;
          width: 100%;
          overflow: hidden;
          position: relative;
          & > img {
            width: 100%;
            height: 100%;
            vertical-align: bottom;
            object-fit: cover;
          }
          .video_time {
            color: $C1;
            font-size: 12px;
            background: $A1;
            width: 56px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-weight: 100;
          }
        }
        .video_intro-wrap {
          width: 100%;
          height: 96px;
          background-color: $C1;
          padding: 20px;
          box-sizing: border-box;
          overflow: hidden;
          .video_title {
            color: $C6;
            font-size: 16px;
            line-height: 17px;
            font-family: HYXinRenWenSongW;
          }
        }
      }
      .activity-item {
        transition: box-shadow 0.3s ease;
        .video_intro-wrap {
          .video_title {
            min-height: 40px;
          }
          .info-wrap {
            font-size: 12px;
            margin: 10px auto 0;
            font-weight: 200;
            margin-bottom: 2px;
            color: $C4;
            line-height: 12px;
          }
        }
        &:hover {
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
        }
      }
      .speech-item,
      .wanxiang-item,
      .record-item {
        height: 256px;
        .video_intro-wrap {
          position: absolute;
          bottom: 0;
          left: 0;
          transition: height 0.3s ease-out;
          .video_intro--content {
            height: 100%;
            width: 100%;
            overflow: hidden;
          }
          .speaker_intro-wrap {
            font-size: 12px;
            margin: 10px auto 2px;
            font-weight: 200;
            color: $C4;
            line-height: 12px;
            .speaker_name {
              margin-right: 10px;
            }
          }
          .video_intro {
            margin-top: 18px;
            font-size: 14px;
            color: $C6;
            line-height: 21px;
            font-weight: 300;
            font-family: 'PingFangSC-Light';
            max-height: 128px;
            overflow: hidden;
            opacity: 0;
          }
          .speaker_intro-wrap .speaker_intro,
          .video_intro {
            opacity: 0;
            transition: opacity 0.3s ease;
          }
        }
        &:hover {
          .video_intro-wrap {
            height: 100%;
            .speaker_intro-wrap {
              color: $C7;
              font-weight: 400;
            }
            .speaker_intro,
            .video_intro {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .wanxiang-swiper-bl {
    .swiper {
      padding-bottom: 5px;
    }
    .swiper-page {
      .wanxiang-item.first {
        max-width: unset;
        width: calc(50% - 10px);
        height: 532px;
        max-height: 532px;
        transition: box-shadow 0.3s ease;
        .cover-wrap {
          height: 396px;
        }
        .wanxiang-intro-wrap {
          height: 136px;
          position: static;
          background-color: $C1;
          padding: 20px;
          box-sizing: border-box;
          .video_title {
            color: $C6;
            font-size: 16px;
            line-height: 17px;
            font-family: HYXinRenWenSongW;
          }
          .video_intro {
            margin-top: 18px;
            font-size: 14px;
            color: $C6;
            line-height: 21px;
            font-weight: 300;
            font-family: 'PingFangSC-Light';
          }
        }
        &:hover {
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
        }
      }
      &-right-wrap {
        display: inline-flex;
        flex-wrap: wrap;
        margin: -10px;
        height: 100%;
        padding: 10px;
        width: calc(50% - 10px);
        vertical-align: top;
        .wanxiang-item {
          width: calc(50% - 20px);
        }
      }
    }
  }
  .zhiya-swiper-bl {
    .swiper {
      padding-bottom: 5px;
      .zhiya-item {
        // width: calc((100% - 60px) / 3 - 0px);
        // max-width: 372px;
        height: 216px;
        display: inline-block;
        vertical-align: bottom;
        transition: box-shadow 0.3s ease;
        &:hover {
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
        }
        .cover-wrap {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
}
</style>
